export enum DocumentTypeObjectAttributeNameEnum {
  NAME = 'name__a',
  TITLE = 'title__a',
  CODE = 'code__a',
  IS_TRAINABLE = 'is_trainable__a',
  DOES_NOT_HAVE_SUBTYPES = 'does_not_have_subtypes__a',
  DOCUMENT_TEMPLATE = 'document_template__a',
  IS_FOLLOW_UP_REQUIRED = 'is_follow_up_required__a',
  FOLLOW_UP_TIME_PERIOD_IN_MONTHS = 'follow_up_time_period_in_months__a',
  IS_ADMIN_REVIEW_REQUIRED = 'is_admin_review_required__a',
  EFFECTIVENESS_PERIOD_IN_DAYS = 'effectiveness_in_days__a',
  DOCUMENT_TYPE = 'document_type__a',
  DOCUMENT_SUB_TYPE = 'document_sub_type__a',
  IS_RAW_FILE_DOWNLOAD_ALLOWED = 'is_raw_file_download_allowed__a',
  IS_ADMIN_APPROVAL_REQUIRED = 'is_admin_approval_required__a',
  SUB_TYPE_CODE = 'sub_type_code__a',
  TEMPLATE_NAME = 'template_name__a',
  FOLLOW_UP_TRIGGER_PERIOD_IN_DAYS = 'follow_up_trigger_periods_in_days__a',
}

export enum DocumentTypeObjectKeyEnum {
  NAME = 'name',
  LABEL = 'label',
  TITLE = 'title',
  CODE = 'code',
  IS_TRAINABLE = 'isTrainable',
  DOES_NOT_HAVE_SUBTYPES = 'doesNotHaveSubTypes',
  DOCUMENT_TEMPLATE = 'documentTemplate',
  IS_FOLLOW_UP_REQUIRED = 'isFollowUpRequired',
  FOLLOW_UP_TIME_PERIOD_IN_MONTHS = 'followUpTimePeriodInMonths',
  IS_ADMIN_REVIEW_REQUIRED = 'isAdminReviewRequired',
  EFFECTIVENESS_PERIOD_IN_DAYS = 'effectivenessPeriodInDays',
  DOCUMENT_TYPE = 'documentType',
  DOCUMENT_SUB_TYPE = 'documentSubType',
  IS_RAW_FILE_DOWNLOAD_ALLOWED = 'isRawFileDownloadAllowed',
  IS_ADMIN_APPROVAL_REQUIRED = 'isAdminApprovalRequired',
  SUB_TYPE_CODE = 'subTypeCode',
  TEMPLATE_NAME = 'templateName',
  FOLLOW_UP_TRIGGER_PERIOD_IN_DAYS = 'followUpTriggerPeriodInDays',
}

export enum DocumentTypeObjectColumnNameEnum {
  NAME = 'name',
  TITLE = 'title',
  CODE = 'code',
  IS_TRAINABLE = 'isTrainable',
  DOES_NOT_HAVE_SUBTYPES = 'doesNotHaveSubTypes',
  DOCUMENT_TEMPLATE = 'documentTemplate',
  IS_FOLLOW_UP_REQUIRED = 'isFollowUpRequired',
  FOLLOW_UP_TIME_PERIOD_IN_MONTHS = 'followUpTimePeriodInMonths',
  IS_ADMIN_REVIEW_REQUIRED = 'isAdminReviewRequired',
  EFFECTIVENESS_PERIOD_IN_DAYS = 'effectivenessPeriodInDays',
  DOCUMENT_TYPE = 'documentType',
  DOCUMENT_SUB_TYPE = 'documentSubType',
  IS_RAW_FILE_DOWNLOAD_ALLOWED = 'isRawFileDownloadAllowed',
  IS_ADMIN_APPROVAL_REQUIRED = 'isAdminApprovalRequired',
  SUB_TYPE_CODE = 'subTypeCode',
  TEMPLATE_NAME = 'templateName',
  FOLLOW_UP_TRIGGER_PERIOD_IN_DAYS = 'followUpTriggerPeriodInDays',
}
